// Sprint T-22 · NotificationFilters · chips read-state + selector de kind
import React from "react";
import { OFFICIAL_KINDS, KINDS_MAP, READ_FILTERS } from "../../lib/notificationKindsMap";

/**
 * Barra de filtros T-22:
 *  · Chips read-state (Todas / No leídas / Leídas)
 *  · Selector nativo `<select>` con los 7 kinds oficiales + “Todas”
 *
 * Props:
 *  · readFilter        · one of "all" | "unread" | "read"
 *  · onReadFilterChange
 *  · kindFilter        · string kind o "" (todas)
 *  · onKindFilterChange
 */
export const NotificationFilters = ({
  readFilter = "all",
  onReadFilterChange,
  kindFilter = "",
  onKindFilterChange,
}) => {
  return (
    <div
      className="flex flex-wrap items-center gap-2"
      data-testid="notif-filters"
      role="toolbar"
      aria-label="Filtros de notificaciones"
    >
      {/* Chips read state */}
      <div className="inline-flex rounded-md border border-[var(--ag-border)] overflow-hidden">
        {READ_FILTERS.map((f) => {
          const active = readFilter === f.key;
          return (
            <button
              key={f.key}
              type="button"
              onClick={() => onReadFilterChange?.(f.key)}
              aria-pressed={active}
              className={[
                "px-3 py-1.5 text-xs font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ag-amber,#f59e0b)]/50",
                active
                  ? "bg-[var(--ag-amber,#f59e0b)] text-[var(--ag-midnight,#0f172a)]"
                  : "bg-transparent text-[var(--ag-text-dim)] hover:text-white hover:bg-[var(--ag-midnight)]/70",
              ].join(" ")}
              data-testid={`notif-filter-read-${f.key}`}
            >
              {f.label}
            </button>
          );
        })}
      </div>

      {/* Selector kind */}
      <label className="sr-only" htmlFor="notif-kind-select">
        Categoría
      </label>
      <select
        id="notif-kind-select"
        value={kindFilter}
        onChange={(e) => onKindFilterChange?.(e.target.value)}
        className="px-3 py-1.5 text-xs bg-[var(--ag-midnight)]/60 border border-[var(--ag-border)] rounded-md text-white focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ag-amber,#f59e0b)]/50"
        data-testid="notif-filter-kind"
      >
        <option value="">Todas las categorías</option>
        {OFFICIAL_KINDS.map((k) => (
          <option key={k} value={k}>
            {KINDS_MAP[k]?.label || k}
          </option>
        ))}
      </select>
    </div>
  );
};

export default NotificationFilters;
